// Si un fichier JS/CSS de l'application échoue au chargement (réseau instable, fichier
// volumineux), l'app restait bloquée sur le spinner. On recharge alors la page UNE seule fois
// par onglet (drapeau de session jamais effacé : aucune boucle de rechargement possible).
const RELOAD_FLAG = 'def_chunk_reload';
const reloadOnceOnChunkError = (err) => {
  const isChunkError =
    !!err &&
    (err.name === 'ChunkLoadError' ||
      /Loading (CSS )?chunk [\w-]+ failed/i.test(err.message || ''));
  if (!isChunkError) return false;
  try {
    if (sessionStorage.getItem(RELOAD_FLAG)) return false;
    sessionStorage.setItem(RELOAD_FLAG, '1');
  } catch (e) {
    return false;
  }
  window.location.reload();
  return true;
};

window.addEventListener('unhandledrejection', (event) =>
  reloadOnceOnChunkError(event.reason),
);

import('./bootstrap').catch((err) => {
  if (!reloadOnceOnChunkError(err)) console.error(err);
});
